import { DragOverlay } from '@dnd-kit/core';
import { useAppSelector } from 'app/hooks';
import { DraggedItemType } from 'components/common/drag-overlay-item';
import {
  DraggedItemOverlay,
  MultiSpaceOverlay,
  SingleGridSpaceOverlay
} from 'components/common/grid-space-overlay';
import { GridSpaceDataType, PositionType } from 'data/types';
import { useMemo } from 'react';
import { createCenterOnCursorModifier } from 'utils/center-drag-overlay-on-cursor';

type StructureDragOverlayProps = {
  activeDragData: {
    type?: string;
    space?: GridSpaceDataType;
    shapePoints?: PositionType[];
  };
  draggedSectionSpaces: GridSpaceDataType[];
  getActiveDraggedItem: () => DraggedItemType;
  zoom?: number;
};

export default function StructureDragOverlay({
  activeDragData,
  draggedSectionSpaces,
  getActiveDraggedItem,
  zoom = 1
}: StructureDragOverlayProps) {
  const { structure } = useAppSelector((state) => state.structure);
  const { easyMode, showZones } = useAppSelector((state) => state.ui);

  const centerOnCursorModifier = useMemo(
    () => createCenterOnCursorModifier(zoom),
    [zoom]
  );

  return (
    <DragOverlay modifiers={[centerOnCursorModifier]} dropAnimation={null}>
      {(() => {
        if (
          activeDragData?.type === 'grid-space' &&
          draggedSectionSpaces.length > 1
        ) {
          return (
            <MultiSpaceOverlay
              structure={structure}
              draggedSectionSpaces={draggedSectionSpaces}
              activeDragData={activeDragData}
              easyMode={easyMode}
              showZones={showZones}
              zoom={zoom}
            />
          );
        }

        if (activeDragData?.type === 'grid-space' && activeDragData?.space) {
          return (
            <SingleGridSpaceOverlay
              space={activeDragData.space}
              showZones={showZones}
              zoom={zoom}
            />
          );
        }

        const draggedItem = getActiveDraggedItem();

        if (!draggedItem) {
          return null;
        }

        return <DraggedItemOverlay draggedItem={draggedItem} zoom={zoom} />;
      })()}
    </DragOverlay>
  );
}
